import { graphql } from '@/generated/gql';

export const INTAKE_ATTACHMENTS_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeAttachmentsUpdate($data: SvbrgAttachmentUpdateInput!) {
    sevenbridges {
      chatSession {
        attachment {
          update(data: $data) {
            id
            name
            createdAt
            isVisible
          }
        }
      }
    }
  }
`);

export const INTAKE_ATTACHMENTS_NEXT_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeAttachmentsNext($data: SvbrgAttachmentNextInput!) {
    sevenbridges {
      chatSession {
        attachment {
          next(data: $data) {
            id
          }
        }
      }
    }
  }
`);
